import React, {
  useCallback,
  useEffect,
  useState
} from "react";

import CursosSelector from "../../Admin/CursosSelector";

import {
  Button as ButtonDefault,
  Container as ContainerDefault,
  Fieldset as FieldsetDefault,
  GroupButtons as GroupButtonsDefault,
  GroupFields as GroupFieldsDefault,
} from "./templates/default";

const Form = ({ template,aluno,setAluno, ...props }) => {
  const [fieldsValues, setFieldsValues] = useState({});

  const Container = template?.Container || ContainerDefault;
  const Fieldset = template?.Fieldset || FieldsetDefault;
  const GroupFields = template?.GroupFields || GroupFieldsDefault;
  const GroupButtons = template?.GroupButtons || GroupButtonsDefault;
  const Button = template?.Button || ButtonDefault;

  const handleInputChange = 
    (e) => {
      const { id, name, value, checked, type } = e.target;

      const newFieldsValues = { ...fieldsValues };

      newFieldsValues[name] = type == "checkbox" ? checked : value;

      setFieldsValues(newFieldsValues);
      if(name && value && aluno ){
        setAluno({...aluno, [name]: value})
      }
      if (props.changeCallback) {
        props.changeCallback(newFieldsValues);
      }
    };
  const handleCommonComponentChange = useCallback(
    ({ name, value }) => {
      const newFieldsValues = { ...fieldsValues };

      newFieldsValues[name] = value;

      setFieldsValues(newFieldsValues);

      if (props.changeCallback) {
        props.changeCallback(newFieldsValues);
      }
    },
    [fieldsValues]
  );

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      props.submitCallback(fieldsValues);
    },
    [props.submitCallback, fieldsValues]
  );

  const getFieldInput = useCallback(
    (field) => {
      const specialInputs = {
        textarea: () => (
          <textarea
            name={field.name}
            value={fieldsValues[field.name]}
            onChange={handleInputChange}
            readOnly={field.readOnly}
          />
        ),
        checkboxes: () => (
          <div>
            {field.choices.map((choice) => (
              <div>
                <label>{choice.label}</label>
                <input
                  type={"checkbox"}
                  name={choice.name}
                  checked={fieldsValues[choice.name]}
                  onChange={handleInputChange}
                  readOnly={field.readOnly}
                />
              </div>
            ))}
          </div>
        ),
        radio: () => (
          <div>
            {field.choices.map((choice) => (
              <div>
                <label>{choice.label}</label>
                <input
                  type={"radio"}
                  name={field.name}
                  id={choice.id}
                  value={choice.id}
                  checked={fieldsValues[field.name] == choice.id}
                  onChange={handleInputChange}
                  readOnly={field.readOnly}
                />
              </div>
            ))}
          </div>
        ),
        select: () => (
          <select name={field.name} onChange={handleInputChange}>
            {field.options.map(({ label, value }) => (
              <option value={value}>{label}</option>
            ))}
          </select>
        ),
        "select-curso": () => (
          <CursosSelector
            handleChange={(value) =>
              handleCommonComponentChange({ name: field.name, value })
            }
          />
        ),
      };

      if (!specialInputs[field.type]) {
        // if(field.mask){
        //   return (
        //     <InputMask
        //     type={field.type || "text"}
        //     name={field.name}
        //     mask={aluno.isCompany ? "ˆ(\d{2})\.(\d{3})\.(\d{3})/(\d{4})-(\d{2})" : "^(\d{3})\.(\d{3})\.(\d{3})-(\d{2})$"} 
        //     value={fieldsValues[field.name]}
        //     onChange={handleInputChange}
        //     readOnly={field.readOnly}
        //     placeholder="cpf/cnpj"
        //     maskChar={null}
        //   />
        //   )
        // }
        return (
          <input
            type={field.type || "text"}
            name={field.name}
            value={fieldsValues[field.name]}
            onChange={handleInputChange}
            readOnly={field.readOnly}
          />
          
        );
      }

      return specialInputs[field.type]();
    },
    [fieldsValues]
  );

  useEffect(() => {
    const newFieldsValues = {};
    const handleField = (field) => {
      if (field.type == "checkboxes") {
        field.choices.map((choice) => {
          newFieldsValues[choice.name] = choice.initialValue || false;
        });
        return;
      }

      if (field.type == "radio") {
        newFieldsValues[field.name] =
          field.choices?.find((choice) => choice.initialValue)?.id || null;
        return;
      }

      newFieldsValues[field.name] = field.initialValue || null;
    };

    props.fields.map((field) => {
      if (!Array.isArray(field)) {
        handleField(field);
        return;
      }

      field.map((subfield) => {
        handleField(subfield);
      });
    });

    setFieldsValues(newFieldsValues);
  }, [props.fields, JSON.stringify(props.fields)]);

  return (
    <Container>
      <form onSubmit={handleSubmit}>
        {props.fields.map((field) => {
          if (Array.isArray(field)) {
            return (
              <GroupFields>
                {field.map((subfield) => (
                  <Fieldset>
                    <label>{subfield.label}</label>

                    {getFieldInput(subfield)}
                  </Fieldset>
                ))}
              </GroupFields>
            );
          }

          return (
            <Fieldset>
              <label>{field.label}</label>

              {getFieldInput(field)}
            </Fieldset>
          );
        })}

        {props.buttons?.map((button) => {
          if (Array.isArray(button)) {
            return (
              <GroupButtons>
                {button.map((subButton) => (
                  <Fieldset>
                    <Button
                      type={subButton.type || "submit"}
                      onClick={subButton.clickCallback}
                      kind={subButton.kind}
                    >
                      {subButton.text || "SEND"}
                    </Button>
                  </Fieldset>
                ))}
              </GroupButtons>
            );
          }

          return (
            <Fieldset>
              <Button
                type={button.type || "submit"}
                onClick={button.clickCallback}
                kind={button.kind}
              >
                {button.text || "SEND"}
              </Button>
            </Fieldset>
          );
        })}
      </form>
    </Container>
  );
};

export default Form;
